/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiUrl
 */
export interface ApiUrl {
  /**
   * URL of the pipeline definition or the pipeline version definition.
   * @type {string}
   * @memberof ApiUrl
   */
  pipeline_url?: string;
}

/**
 * Check if a given object implements the ApiUrl interface.
 */
export function instanceOfApiUrl(value: object): value is ApiUrl {
  return true;
}

export function ApiUrlFromJSON(json: any): ApiUrl {
  return ApiUrlFromJSONTyped(json, false);
}

export function ApiUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUrl {
  if (json == null) {
    return json;
  }
  return {
    pipeline_url: json['pipeline_url'] == null ? undefined : json['pipeline_url'],
  };
}

export function ApiUrlToJSON(json: any): ApiUrl {
  return ApiUrlToJSONTyped(json, false);
}

export function ApiUrlToJSONTyped(
  value?: ApiUrl | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_url: value['pipeline_url'],
  };
}
